import React, { } from "react";
import { Form, Col } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';

export default function SettingTimer(props) {
    const questionIndex = props.index;
    const data = parseInt(props.data) || 0;
    const dispatch = useDispatch();
    // console.log(props);

    function onChange(e) {
        try {
            const tmp = parseInt(e.target.value);
            if (tmp < 0) tmp = 0;
            console.log(tmp)
            dispatch({
                type: "QUESTION_SET_MA",
                key: "timer",
                index: questionIndex,
                data: tmp
            });
        } catch (e) {

        }
    }

    function render() {
        return (
            <Form.Group>
                <Form>
                    <Form.Row>
                        <Form.Label column xs="3">強制題目閱讀時間(秒):</Form.Label>
                        <Col className="text-left">
                            <Form.Control onChange={onChange} type="number" name={questionIndex + "rand-sub"} value={Math.floor(data)} />
                        </Col>
                    </Form.Row>
                </Form>
            </Form.Group>
        );
    }

    return render();
}
